var UICheckbox = (function ($) {

    UICheckbox = function () {
        var that = this;

        // DOM

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UICheckbox.prototype.class = {
        error: 'error',
    };

    UICheckbox.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UICheckbox.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('change', '.checkbox input', function () {
            var $checkbox_input = $(this),
                $checkbox = $checkbox_input.parents('.checkbox');

            $checkbox.removeClass(that.class.error);
        });

    };

    UICheckbox.prototype.__clearValue = function ($checkbox) {
        var $checkbox_input = $checkbox.find('input');

        $checkbox_input.prop('checked', false).change();
        $checkbox_input.attr('checked', false).change();
    };

    return UICheckbox;
})($);
